import {
    Card,
    CardContent,
    Stack,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
} from "@mui/material"
import { Repeat } from "lib/@components/repeat"
import { If } from "lib/@components/switch"
import { CostTimeModifierRow } from "./cost-time-modifier-row"

export function CostTimeModifiersSection({ costResult }) {
    const impacts = (costResult?.ruleSetImpact || []).filter(isTimeImpact)
    const totalAnnualHoursAdded = costResult?.totalTimeDeltaAnnualHours || 0

    return (
        <If value={impacts.length > 0}>
            <Card data-cy="time-modifiers-section">
                <CardContent sx={{ p: 3 }}>
                    <Stack spacing={2}>
                        <Stack direction="row" justifyContent="space-between" alignItems="baseline">
                            <Typography variant="h6">Time modifiers</Typography>
                            <Typography variant="body2" color="text.secondary">
                                {formatHours(totalAnnualHoursAdded)} hrs/year total
                            </Typography>
                        </Stack>
                        <TableContainer>
                            <Table size="small">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Rule</TableCell>
                                        <TableCell align="right">Matched tasks</TableCell>
                                        <TableCell align="right">Per task</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    <Repeat list={impacts} item={<CostTimeModifierRow />} />
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Stack>
                </CardContent>
            </Card>
        </If>
    )
}

function isTimeImpact(impact) {
    return impact?.action === "timeModifier" || impact?.timeKind != null
}

function formatHours(hours) {
    if (!Number.isFinite(hours)) return "0.0"
    return (Math.round(hours * 10) / 10).toFixed(1)
}
